<div class="login-page" [style.background-image]="'url(' + bgLoginPath + ')'">
  <div class="login-page__container">
    <div class="login-card">
      <div class="login-card__header">
        <img [src]="logoPath" alt="Logo" class="login-card__logo">
        <h1 class="login-card__title">Thiết lập xác thực 2 lớp</h1>
        <p class="login-card__subtitle" *ngIf="!enrolled">
          Quét mã QR bằng ứng dụng Authenticator (Google/Microsoft Authenticator, Authy…) rồi nhập mã 6 số để xác nhận
        </p>
        <p class="login-card__subtitle" *ngIf="enrolled">
          Lưu lại các mã khôi phục dưới đây ở nơi an toàn — dùng khi mất thiết bị
        </p>
      </div>

      <!-- Bước 1: quét QR + xác nhận mã -->
      <form *ngIf="!enrolled" [formGroup]="form" class="login-card__form" (ngSubmit)="submit()">
        <div class="qr-box">
          <div *ngIf="loadingQr" class="qr-loading">Đang tạo mã QR…</div>
          <img *ngIf="qrDataUri" [src]="qrDataUri" alt="Mã QR TOTP" class="qr-img">
        </div>

        <div class="secret-hint" *ngIf="secret">
          <span>Không quét được? Nhập tay mã bí mật vào app:</span>
          <code class="secret-code">{{ secret }}</code>
        </div>

        <div class="login-field">
          <hbt-input-text
            class="login-input"
            [defaultInput]="true"
            labelText="Mã xác thực"
            placeholderText="Nhập mã 6 số"
            formControlName="code"
            [type]="isSubmitted && f['code'].errors ? 'error' : 'default'"
            [showError]="isSubmitted && f['code'].errors !== null"
            [errors]="f['code'].errors"
            [errorDefs]="[{ errorName: 'required', errorDescription: 'Bắt buộc nhập mã xác thực' }]">
          </hbt-input-text>
        </div>

        <button type="submit" class="login__btn" nz-button [disabled]="isLoading || loadingQr">
          Xác nhận & Bật 2FA
        </button>
        <div class="login-links">
          <a (click)="backToLogin()" class="login-links__item">Quay lại đăng nhập</a>
        </div>
      </form>

      <!-- Bước 2: hiển thị recovery codes -->
      <div *ngIf="enrolled" class="login-card__form">
        <div class="recovery-warning">
          Mỗi mã chỉ dùng được 1 lần. Hãy lưu ở nơi an toàn để đăng nhập khi mất điện thoại.
        </div>
        <div class="recovery-list">
          <code *ngFor="let c of recoveryCodes" class="recovery-code">{{ c }}</code>
        </div>
        <button type="button" class="login__btn" nz-button (click)="continueToApp()">
          Tôi đã lưu, tiếp tục
        </button>
      </div>

      <p class="login-card__footer">
        © 2026 • Trường Đại học Thương mại • Cổng đăng nhập SSO
      </p>
    </div>
  </div>
</div>
